"use strict";

exports.__esModule = true;
var Utils_1 = require("../utils/Utils");
var CreditCardList_1 = require("../utils/CreditCardList");
var CreditCard = function () {
  function CreditCard() {}
  CreditCard.getCardFlagName = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return "";
    var keys = Object.keys(CreditCardList_1.CreditCardList);
    for (var i in keys) {
      var key = keys[i];
      var card = CreditCardList_1.CreditCardList[key];
      if (card.pattern.test(value)) return card.name;
    }
    return "";
  };
  CreditCard.getCardFlagSlug = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return "";
    var keys = Object.keys(CreditCardList_1.CreditCardList);
    for (var i in keys) {
      var key = keys[i];
      var card = CreditCardList_1.CreditCardList[key];
      if (card.pattern.test(value)) return card.slug;
    }
    return "";
  };
  CreditCard.filter = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!CreditCard.validateFlag(value)) return value;
    if (!value) return "";
    var keys = Object.keys(CreditCardList_1.CreditCardList);
    for (var i in keys) {
      var key = keys[i],
        card = CreditCardList_1.CreditCardList[key],
        valid = card.pattern.test(value),
        slices = card.groupPattern.exec(value),
        returnable = [];
      if (valid && slices[1] !== undefined) {
        for (var s = 1; s < slices.length; s++) {
          if (slices[s] !== undefined) {
            returnable.push(slices[s]);
          }
        }
        if (returnable.length > 0) return returnable.join(" ");
      }
    }
    return value;
  };
  CreditCard.format = function (value) {
    return CreditCard.filter(value);
  };
  CreditCard.mask = function (value, maskWith) {
    if (maskWith === void 0) {
      maskWith = "x";
    }
    if (!CreditCard.validateFlag(value)) return value;
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return "";
    var keys = Object.keys(CreditCardList_1.CreditCardList);
    for (var i in keys) {
      var key = keys[i],
        card = CreditCardList_1.CreditCardList[key],
        slices = card.groupPattern.exec(value),
        returnable = [];
      if (slices[1] !== undefined) {
        for (var s = 1; s < slices.length; s++) {
          if (slices[s] !== undefined) {
            if (s > 1) {
              returnable.push(slices[s].replace(/\d/g, maskWith));
            } else {
              returnable.push(slices[s]);
            }
          }
        }
        if (returnable.length > 0) return returnable.join("-");
      }
    }
    return value;
  };
  CreditCard.validateDigit = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return false;
    var exploded = value.trim().split(""),
      sum = 0,
      digit = exploded.pop(),
      check;
    exploded = exploded.reverse();
    for (var n = 0; n < exploded.length; n++) {
      var _value = parseInt(exploded[n]);
      sum += n % 2 === 0 ? CreditCard.MODULO[_value] : _value;
    }
    check = (10 - sum % 10) % 10;
    return check === parseInt(digit);
  };
  CreditCard.validateFlag = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return false;
    var keys = Object.keys(CreditCardList_1.CreditCardList);
    for (var i in keys) {
      var key = keys[i];
      var card = CreditCardList_1.CreditCardList[key];
      if (card.pattern.test(value)) return card.slug;
    }
    return false;
  };
  CreditCard.validateModulo = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return false;
    var exploded = value.trim().split(""),
      sum = 0;
    exploded = exploded.reverse();
    for (var n = 0; n < exploded.length; n++) {
      var _value = parseInt(exploded[n]);
      sum += n % 2 === 0 ? _value : CreditCard.MODULO[_value];
    }
    return sum % 10 === 0;
  };
  CreditCard.validateSequence = function (value) {
    value = Utils_1.SanitizeToDigitsWithAssertion(value);
    if (!value) return false;
    var len = value.length;
    return !Utils_1.CheckNumberRepetition(value, len);
  };
  CreditCard.MODULO = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];
  return CreditCard;
}();
exports.CreditCard = CreditCard;